export default "__VITE_ASSET__b1oJ9jjP__"